import { render, staticRenderFns } from "./MyLeaveCredits.vue?vue&type=template&id=513546c1&scoped=true"
import script from "./MyLeaveCredits.vue?vue&type=script&lang=js"
export * from "./MyLeaveCredits.vue?vue&type=script&lang=js"
import style0 from "./MyLeaveCredits.vue?vue&type=style&index=0&id=513546c1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513546c1",
  null
  
)

export default component.exports